// Auto Generated by gen_candidates.py
export const CANDIDATE_D_LIST = [
  {
    regNum: 14,
    regDate: "2024-08-02",
    id: "AD",
    firstNameShort: "Akmeemana",
    firstNames: "Akmeemana",
    lastName: "Dayarathana",
    gender: "male",
    party: "Independent",
    support: null,
    imgFile: "1523.jpg",
    xHandle: "null",
    wikipediaPage: "Akmeemana_Dayarathana_Thero",
    parliamentNum: 1523,
    linkedInID: "null",
    manthriLKID: "null",
  },
  {
    regNum: 11,
    regDate: "2024-08-02",
    id: "AK",
    firstNameShort: "Ananda",
    firstNames: "K Ananda",
    lastName: "Kularatne",
    gender: "male",
    party: "Independent",
    support: null,
    imgFile: "null",
    xHandle: "null",
    wikipediaPage: "null",
    parliamentNum: "null",
    linkedInID: "null",
    manthriLKID: "null",
  },
  {
    regNum: 18,
    regDate: "2024-08-06",
    id: "AKD",
    firstNameShort: "Anura Kumara",
    firstNames: "Disanayake Mudiyanselage Anura Kumara",
    lastName: "Disanayake",
    gender: "male",
    party: "NPP",
    support: "JVP",
    imgFile: "112.jpg",
    xHandle: "AnuraDisanayake",
    wikipediaPage: "Anura_Kumara_Dissanayake",
    parliamentNum: 112,
    linkedInID: "anuradissanayake",
    manthriLKID: "anura-kumara-dissanayaka",
  },
  {
    regNum: 4,
    regDate: "2024-07-26",
    id: "AL",
    firstNameShort: "ASP",
    firstNames: "ASP",
    lastName: "Liyanage",
    gender: "male",
    party: "SLLP",
    support: null,
    imgFile: "ASPL.png",
    xHandle: "null",
    wikipediaPage: "A._S._P._Liyanage",
    parliamentNum: "null",
    linkedInID: "null",
    manthriLKID: "null",
  },
  {
    regNum: 10,
    regDate: "2024-08-01",
    id: "AZ",
    firstNameShort: "Ajantha",
    firstNames: "Ajantha",
    lastName: "de Zoysa",
    gender: "male",
    party: "RJP",
    support: null,
    imgFile: "284.jpg",
    xHandle: "null",
    wikipediaPage: "null",
    parliamentNum: 284,
    linkedInID: "ajantha-zoysa-42a2b2101",
    manthriLKID: "null",
  },
  {
    regNum: 13,
    regDate: "2024-08-02",
    id: "BS",
    firstNameShort: "Battaramulle",
    firstNames: "Battaramulle",
    lastName: "Seelarathana",
    gender: "male",
    party: "JP",
    support: null,
    imgFile: "BS.png",
    xHandle: "null",
    wikipediaPage: "null",
    parliamentNum: "null",
    linkedInID: "null",
    manthriLKID: "null",
  },
  {
    regNum: "null",
    regDate: "null",
    id: "DJ",
    firstNameShort: "Dilith",
    firstNames: "Dilith",
    lastName: "Jayaweera",
    gender: "male",
    party: "MJP",
    support: null,
    imgFile: "DJ.jpg",
    xHandle: "Dilith_J",
    wikipediaPage: "Dilith_Jayaweera",
    parliamentNum: "null",
    linkedInID: "dilith-jayaweera",
    manthriLKID: "null",
  },
  {
    regNum: "null",
    regDate: "null",
    id: "JR",
    firstNameShort: "Janaka",
    firstNames: "Janaka",
    lastName: "Ratnayake",
    gender: "male",
    party: "Independent",
    support: null,
    imgFile: "JR.jpg",
    xHandle: "null",
    wikipediaPage: "Janaka_Ratnayake",
    parliamentNum: "null",
    linkedInID: "null",
    manthriLKID: "null",
  },
  {
    regNum: 16,
    regDate: "2024-08-05",
    id: "KK",
    firstNameShort: "KR",
    firstNames: "KR",
    lastName: "Krishan",
    gender: "male",
    party: "AJP",
    support: null,
    imgFile: "null",
    xHandle: "null",
    wikipediaPage: "null",
    parliamentNum: "null",
    linkedInID: "null",
    manthriLKID: "null",
  },
  {
    regNum: 8,
    regDate: "2024-08-01",
    id: "KP",
    firstNameShort: "KK",
    firstNames: "KK",
    lastName: "Piyadasa",
    gender: "male",
    party: "Independent",
    support: null,
    imgFile: "297.jpg",
    xHandle: "null",
    wikipediaPage: "null",
    parliamentNum: 297,
    linkedInID: "null",
    manthriLKID: "k-k-piyadasa",
  },
  {
    regNum: "null",
    regDate: "null",
    id: "NB",
    firstNameShort: "Nuwan",
    firstNames: "Nuwan",
    lastName: "Bopage",
    gender: "male",
    party: "PSA",
    support: "FSP",
    imgFile: "NB.png",
    xHandle: "null",
    wikipediaPage: "null",
    parliamentNum: "null",
    linkedInID: "null",
    manthriLKID: "null",
  },
  {
    regNum: "null",
    regDate: "null",
    id: "NR",
    firstNameShort: "Namal",
    firstNames: "Namal",
    lastName: "Rajapakse",
    gender: "male",
    party: "SLPP",
    support: "SLPP (Rajapakse)",
    imgFile: "3179.jpg",
    xHandle: "RajapaksaNamal",
    wikipediaPage: "Namal_Rajapaksa",
    parliamentNum: 3179,
    linkedInID: "namalrajapaksa",
    manthriLKID: null,
  },
  {
    regNum: 3,
    regDate: "2024-07-26",
    id: "OH",
    firstNameShort: "Oshala",
    firstNames: "Hitihamilage Don Oshala Lakmal Anil Herath",
    lastName: "Herath",
    gender: "male",
    party: "NIF",
    support: null,
    imgFile: "OH.png",
    xHandle: "OshalaHerath",
    wikipediaPage: "null",
    parliamentNum: "null",
    linkedInID: "oshalaherath",
    manthriLKID: "null",
  },
  {
    regNum: 6,
    regDate: "2024-07-31",
    id: "PB",
    firstNameShort: "PWSK",
    firstNames: "PWSK",
    lastName: "Bandaranayake",
    gender: "male",
    party: "JSP",
    support: null,
    imgFile: "PB.png",
    xHandle: "null",
    wikipediaPage: "null",
    parliamentNum: "null",
    linkedInID: "dr-p-w-s-k-bandaranayake-323a2221a",
    manthriLKID: "null",
  },
  {
    regNum: 1,
    regDate: "2024-07-26",
    id: "RW",
    firstNameShort: "Ranil",
    firstNames: "Ranil",
    lastName: "Wickramasinghe",
    gender: "male",
    party: "Independent",
    support: "SLPP (breakaway), UNP, MEP, EPDP, SLFP (Siripala)",
    imgFile: "1244.jpg",
    xHandle: "RW_UNP",
    wikipediaPage: "Ranil_Wickremesinghe",
    parliamentNum: 1244,
    linkedInID: "null",
    manthriLKID: "ranil-wickremesinghe",
  },
  {
    regNum: 15,
    regDate: "2024-08-05",
    id: "SA",
    firstNameShort: "Siripala",
    firstNames: "Siripala",
    lastName: "Amarasinghe",
    gender: "male",
    party: "Independent",
    support: null,
    imgFile: "1422.jpg",
    xHandle: "null",
    wikipediaPage: "null",
    parliamentNum: 1422,
    linkedInID: "null",
    manthriLKID: "null",
  },
  {
    regNum: 17,
    regDate: "2024-08-05",
    id: "SF",
    firstNameShort: "Sarath",
    firstNames: "Gardihewa Sarath Chandralal",
    lastName: "Fonseka",
    gender: "male",
    party: "Independent",
    support: null,
    imgFile: "3135.jpg",
    xHandle: "GeneralFonseka",
    wikipediaPage: "Sarath_Fonseka",
    parliamentNum: 3135,
    linkedInID: "field-marshal-sarath-fonseka-465815179",
    manthriLKID: "sarath-fonseka",
  },
  {
    regNum: 9,
    regDate: "2024-08-01",
    id: "SJ",
    firstNameShort: "Siritunga",
    firstNames: "Siritunga",
    lastName: "Jayasuriya",
    gender: "male",
    party: "USP",
    support: null,
    imgFile: "SJ.jpg",
    xHandle: "null",
    wikipediaPage: "Siritunga_Jayasuriya",
    parliamentNum: "null",
    linkedInID: "null",
    manthriLKID: "null",
  },
  {
    regNum: 2,
    regDate: "2024-07-26",
    id: "SK",
    firstNameShort: "Sarath",
    firstNames: "Sarath",
    lastName: "Keerthirathna",
    gender: "male",
    party: "Independent",
    support: null,
    imgFile: "SK.jpg",
    xHandle: "null",
    wikipediaPage: "null",
    parliamentNum: 3038,
    linkedInID: "null",
    manthriLKID: "null",
  },
  {
    regNum: 12,
    regDate: "2024-08-02",
    id: "SM",
    firstNameShort: "Sarath ",
    firstNames: "Sarath ",
    lastName: "Manamendra",
    gender: "male",
    party: "NSU",
    support: null,
    imgFile: "SM.png",
    xHandle: "null",
    wikipediaPage: "null",
    parliamentNum: "null",
    linkedInID: "sarath-manamendra-6b9b183a",
    manthriLKID: "null",
  },
  {
    regNum: 5,
    regDate: "2024-07-31",
    id: "SP",
    firstNameShort: "Sajith",
    firstNames: "Sajith",
    lastName: "Premadasa",
    gender: "male",
    party: "SJB",
    support: "SLFP (Dayasiri), SLMC, UCPF, TPA",
    imgFile: "140.jpg",
    xHandle: "SajithPremadasa",
    wikipediaPage: "Sajith_Premadasa",
    parliamentNum: 140,
    linkedInID: "sajithpremadasa",
    manthriLKID: "sajith-premadasa",
  },
  {
    regNum: 7,
    regDate: "2024-08-01",
    id: "WR",
    firstNameShort: "Wijeyadasa",
    firstNames: "Wijeyadasa",
    lastName: "Rajapakshe",
    gender: "male",
    party: "JPP",
    support: "SLFP (Sirisena)",
    imgFile: "1521.jpg",
    xHandle: "WijeRajapakshe",
    wikipediaPage: "Wijeyadasa_Rajapakshe",
    parliamentNum: 1521,
    linkedInID: "wijeyadasa-rajapakshe",
    manthriLKID: "wijeyadasa-rajapakshe",
  },
];
